export default {
    product_pricing: {
        get_1_month_extra_for_free: 'Get 1 month extra for FREE',
        get_2_months_extra_for_free: 'Get 2 months extra for FREE',
    },
    product_descriptions: {
        get_started_with_your_own_virtual_server:
            'Get started with your own virtual server',
        more_resources_for_your_work: 'More resources for your work',
        a_natural_fit_for_small_and_medium_businesses:
            'A natural fit for small and medium businesses',
        designed_specifically_for_high_class_enterprises:
            'Designed specifically for high-class enterprises',
    },
};
